<template>
  <v-row>
    <v-col cols="12">
      <v-form class="ma-6 pa-0">
        <template v-for="(row, index) in filterRows">
          <v-row class="mb-0" :key="index">
            <v-col cols="12" md="4" style="margin-bottom: 0; padding-bottom: 0">
              <v-menu
                ref="date"
                v-model="row.menuPay"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="row.datePays"
                    label="Дата расхода по объектам в период даты дохода"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="row.datePays"
                  range
                  locale="ru-RU"
                  :first-day-of-week="1"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="row.menuPay = false">
                    Отмена
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.date[index].save(row.datePays)"
                  >
                    Сохранить
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-autocomplete
                class="mb-0"
                v-model="row.statObjSelect"
                :items="row.statObj"
                item-text="NAME"
                item-value="ID"
                label="Статья расхода"
                multiple
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col>
              <v-autocomplete
                class="mb-0"
                v-model="row.objSelect"
                :items="obj"
                @input="getStatObj(row)"
                item-text="NAME"
                item-value="ID"
                label="Объект"
                outlined
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="mt-0" :key="index + '/btn'">
            <a class="mr-4" @click="addFilterRow(row)">добавить</a>
            <a class="mr-4" @click="deleteFilterRow(row)">удалить</a>
          </v-row>
        </template>
        <v-row>
          <v-btn
            text
            color="success"
            class="mr-4 mt-3"
            @click="getReportToFilter"
            :disabled="loading"
          >
            сформировать
          </v-btn>
          <v-btn
            text
            color="orange"
            class="mr-4 mt-3"
            @click="exportXLS"
            :disabled="loading"
          >
            EXPORT XLS
          </v-btn>
        </v-row>
      </v-form>
    </v-col>
    <v-col>
      <template>
        <v-simple-table v-bind="$attrs" class="my-table">
          <thead>
            <tr class="gray">
              <th
                v-for="column in headers"
                :key="column.name"
                :colspan="column.cols"
              >
                {{ column.title }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(row, index) in rows">
              <tr :key="`main${index}`">
                <td :rowspan="row.rowspan">{{ row.contragent }}</td>
                <td :rowspan="row.rowspan">{{ row.obj }}</td>
                <td :rowspan="row.rowspan">{{ row.contract }}</td>
                <td :rowspan="row.rowspan">{{ row.addTermsCost }}</td>
                <td :rowspan="row.rowspan">{{ row.planSpend }}</td>
                <td :rowspan="row.rowspan">{{ row.planProfit }}</td>
                <td>{{ row.payDate[0] }}</td>
                <td>{{ row.paySum[0] }}</td>
                <td>{{ row.actDate[0] }}</td>
                <td>{{ row.actSum[0] }}</td>
                <td>{{ row.spendCat[0] }}</td>
                <td>{{ row.spendSum[0] }}</td>
                <td :rowspan="row.rowspan">{{ row.factRevenue }}</td>
                <td :rowspan="row.rowspan">{{ row.factRevenuePercent }}</td>
                <td :rowspan="row.rowspan">{{ row.planFactSpendDiff }}</td>
                <td :rowspan="row.rowspan">{{ row.revenueDiffPercent }}</td>
              </tr>
              <template v-for="subRowIndex in row.rowspan - 1">
                <tr :key="`sr${index}-${subRowIndex}`">
                  <td>{{ row.payDate[subRowIndex] }}</td>
                  <td>{{ row.paySum[subRowIndex] }}</td>
                  <td>{{ row.actDate[subRowIndex] }}</td>
                  <td>{{ row.actSum[subRowIndex] }}</td>
                  <td>{{ row.spendCat[subRowIndex] }}</td>
                  <td>{{ row.spendSum[subRowIndex] }}</td>
                </tr>
              </template>
              <tr :key="`sum${index}`" class="orange">
                <td colspan="2"></td>
                <td>ИТОГО</td>
                <td>{{ row.summedRow.addTermsCost }}</td>
                <td>{{ row.summedRow.planSpend }}</td>
                <td>{{ row.summedRow.planProfit }}</td>
                <td></td>
                <td>{{ row.summedRow.paySum }}</td>
                <td></td>
                <td>{{ row.summedRow.actSum }}</td>
                <td></td>
                <td>{{ row.summedRow.spendSum }}</td>
                <td>{{ row.summedRow.factRevenue }}</td>
                <td>{{ row.summedRow.factRevenuePercent }}</td>
                <td>{{ row.summedRow.planFactSpendDiff }}</td>
                <td>{{ row.summedRow.revenueDiffPercent }}</td>
              </tr>
            </template>
            <template v-if="loading === true">
              <v-progress-linear
                :active="loading"
                :indeterminate="loading"
                absolute
                top
                color="light-green darken-4"
                height="10"
              ></v-progress-linear>
            </template>
            <template v-if="rows.length > 0">
              <tr class="gray">
                <td colspan="3">ИТОГИ ПО ВСЕМ ОБЪЕКТАМ</td>
                <td>{{ totalSumToObjs.addTermsCost }}</td>
                <td>{{ totalSumToObjs.planSpend }}</td>
                <td>{{ totalSumToObjs.planProfit }}</td>
                <td></td>
                <td>{{ totalSumToObjs.paySum }}</td>
                <td></td>
                <td>{{ totalSumToObjs.actSum }}</td>
                <td></td>
                <td>{{ totalSumToObjs.spendSum }}</td>
                <td></td>
                <td></td>
                <td colspan="2"></td>
              </tr>
              <tr class="gray">
                <td colspan="11">ВСЕ ВЫДАННЫЕ ПРЕМИИ с объеков :</td>
                <td>{{ totalSumToObjs.bonus }}</td>
                <td colspan="15"></td>
              </tr>
              <tr class="gray">
                <td colspan="11">Итого Доход :</td>
                <td>{{ totalSumToObjs.total }}</td>
                <td colspan="15"></td>
              </tr>
              <tr class="gray">
                <td colspan="11">Расходы Сити-Строй :</td>
                <td>{{ totalCityStroy.all }}</td>
                <td colspan="15"></td>
              </tr>
              <tr class="gray">
                <td colspan="11">Налоги (предыдущий квартал) :</td>
                <td>{{ totalCityStroy.nds }}</td>
                <td colspan="15"></td>
              </tr>
              <tr class="gray">
                <td colspan="11">Прочее</td>
                <td>{{ totalCityStroy.other }}</td>
                <td colspan="15"></td>
              </tr>
              <tr class="gray">
                <td colspan="11">Айти+Бухгалтер</td>
                <td>{{ totalCityStroy.it }}</td>
                <td colspan="15"></td>
              </tr>
              <tr class="gray">
                <td colspan="11">ЗП</td>
                <td>{{ totalCityStroy.salary }}</td>
                <td colspan="15"></td>
              </tr>
              <tr class="gray">
                <td colspan="11">Задолженности прошедших периодов :</td>
                <td>{{ totalCityStroy.debt }}</td>
                <td colspan="15"></td>
              </tr>
              <tr class="gray">
                <td colspan="8">Доход Сити-Строя :</td>
                <td>{{ totalCityStroy.profit }}</td>
                <td colspan="15"></td>
              </tr>
              <tr class="gray">
                <td colspan="11">Доход предыдущего квартала :</td>
                <td>0,00</td>
                <td colspan="15"></td>
              </tr>
              <tr class="gray">
                <td colspan="11">Итоговый доход Сити-Строя :</td>
                <td>0,00</td>
                <td colspan="15"></td>
              </tr>
              <tr class="gray">
                <td colspan="11">Премия Зорин :</td>
                <td>0,00</td>
                <td colspan="15"></td>
              </tr>
              <tr class="gray">
                <td colspan="11">Премия Хамзина :</td>
                <td>0,00</td>
                <td colspan="15"></td>
              </tr>
              <tr class="gray">
                <td colspan="11">Чистый доход Сити-Строя :</td>
                <td>0,00</td>
                <td colspan="15"></td>
              </tr>
              <tr class="gray">
                <td colspan="11">КМ :</td>
                <td>{{ totalCityStroy.km }}</td>
                <td colspan="15"></td>
              </tr>
              <tr class="gray">
                <td colspan="11">Мостовой :</td>
                <td>{{ totalCityStroy.most }}</td>
                <td colspan="15"></td>
              </tr>
            </template>
          </tbody>
        </v-simple-table>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import exeljs from "exceljs";
import fileWrite from "file-saver";

export default {
  name: "quarterly_report",
  data() {
    return {
      headers: [
        { name: "contragent", title: "Контрагент", cols: 1 },
        { name: "obj", title: "Название объекта", cols: 1 },
        { name: "contract", title: "Договор", cols: 1 },
        {
          name: "addTermsCost",
          title: "Сумма подписанного ДС с НДС20%",
          cols: 1,
        },
        { name: "planSpend", title: "Плановые расходы  с НДС 20%", cols: 1 },
        { name: "planProfit", title: "Плановая прибыль", cols: 1 },
        { name: "payDate", title: "Дата оплаты", cols: 1 },
        { name: "paySum", title: "Сумма оплаты  с НДС 20%", cols: 1 },
        { name: "actDate", title: "Дата акта выполненых работ", cols: 1 },
        {
          name: "actSum",
          title: "Сумма выполненных работ (акт кс-2) с НДС 20%",
          cols: 1,
        },
        { name: "spendCat", title: "Статья расходов", cols: 1 },
        { name: "spendSum", title: "Сумма с НДС 20%", cols: 1 },
        { name: "factRevenue", title: "Доход фактический", cols: 1 },
        { name: "factRevenuePercent", title: "% доходности", cols: 1 },
        {
          name: "planFactSpendDiff",
          title: "План расход- фактический расход",
          cols: 1,
        },
        { name: "revenueDiff", title: "ОТКЛОНЕНИЕ ДОХОДНОСТИ(%)", cols: 1 },
      ],
      filterRows: [
        {
          id: 1,
          datePays: [],
          menuPay: false,
          objSelect: [],
          statObjSelect: [],
          statObj: [],
        },
      ],
      loading: false,
      datePays: [],
      normalDate: [],
      menuPay: false,
      obj: [],
      objSelect: "",
      statObj: [],
      statObjSelect: [],
      rows: [],
      spendRow: [],
      payRow: [],
      actRow: [],
      rowData: [[], []],
      rowCityStroy: [],
      totalSumToObjs: {
        addTermsCost: 0,
        planSpend: 0,
        planProfit: 0,
        paySum: 0,
        actSum: 0,
        spendSum: 0,
        margin: 0,
        planFactSpendDiff: 0,
        bonus: 0,
        total: 0,
        xls: {
          addTermsCost: 0,
          planSpend: 0,
          planProfit: 0,
          paySum: 0,
          actSum: 0,
          spendSum: 0,
          margin: 0,
          planFactSpendDiff: 0,
          bonus: 0,
          total: 0,
        },
      },
      totalCityStroy: {
        nds: 0,
        it: 0,
        other: 0,
        debt: 0,
        salary: 0,
        km: 0,
        most: 0,
        all: 0,
        profit: 0,
        xls: {
          nds: 0,
          it: 0,
          other: 0,
          debt: 0,
          salary: 0,
          km: 0,
          most: 0,
          all: 0,
          profit: 0,
        },
      },
      rowspan: 0,
      url: "https://citystroi.bitrix24.ru/rest/73/gjdt5g3y10jxw3r9/",
    };
  },
  methods: {
    addFilterRow(row) {
      this.filterRows.push({
        id: row.id + 1,
        datePays: [],
        menuPay: false,
        objSelect: [],
        statObj: [],
        statObjSelect: [],
      });
    },
    deleteFilterRow(row) {
      if (row.id > 1) {
        const rowId = this.filterRows.indexOf((elem) => elem.id === row.id);
        this.filterRows.splice(rowId, 1);
      } else {
        alert("Нельзя удалять первый фильтр!");
      }
    },
    async normalizeDate(dates) {
      try {
        console.log({ dates });
        this.normalDate = [];
        const firstDate = dates[0].split("-");
        const twoDate = dates[1].split("-");
        const firstDateFormated =
          firstDate[2] + "." + firstDate[1] + "." + firstDate[0] + " 00:00:00";
        const twoDateFormated =
          twoDate[2] + "." + twoDate[1] + "." + twoDate[0] + " 23:59:59";
        this.normalDate.push(firstDateFormated);
        this.normalDate.push(twoDateFormated);
        console.log({ firstDate });
        console.log({ twoDate });
        console.log({ firstDateFormated });
        console.log({ twoDateFormated });
      } catch (e) {
        console.log(e);
      }
    }, //++
    async getObj() {
      try {
        this.obj = [];
        const params = {
          IBLOCK_TYPE_ID: "lists",
          IBLOCK_ID: "97",
        };
        const method = "lists.element.get";
        let i = 1;
        let next = 0;
        while (i > 0) {
          params.start = next;
          const objData = await axios.post(this.url + method, params);
          next = objData.data.next;
          for (const elem of objData.data.result) {
            this.obj.push(elem);
          }
          if (!next) {
            i = 0;
          }
        }
      } catch (e) {
        console.log(e);
      }
    }, //++
    async getStatObj(row) {
      try {
        console.log({ row });
        console.log("getStatObj");
        try {
          const params = {
            IBLOCK_TYPE_ID: "lists",
            IBLOCK_ID: "97",
            ELEMENT_ID: row.objSelect,
          };
          const method = "lists.element.get";
          const objData = await axios.post(this.url + method, params);
          console.log({ objData });
          const statObjData = Object.values(
            objData.data.result[0].PROPERTY_891
          )[0];
          for (const stat of statObjData.split(";")) {
            let pushStat = stat.replace(/[^a-zа-яё0-9\s]/gi, "");
            //pushStat = pushStat.trim()
            if (pushStat != " " || pushStat != "") row.statObj.push(pushStat);
          }
          console.log(row.statObj);
          /*  row.statObj.sort((a, b) => {
            if (a["NAME"] < b["NAME"]) {
              return -1;
            }
            if (a["NAME"] > b["NAME"]) {
              return 1;
            }
            // a должно быть равным b
            return 0;
          });*/
        } catch (e) {
          console.log(e);
        }
      } catch (e) {
        console.log(e);
      }
    }, //++
    async getSpendRow(filterRow) {
      try {
        await this.normalizeDate(filterRow.datePays);
        const params = {
          IBLOCK_TYPE_ID: "lists",
          IBLOCK_ID: "45",
          FILTER: {
            ">=PROPERTY_691": this.normalDate[0],
            "<=PROPERTY_691": this.normalDate[1],
          },
        };
        // console.log('getSpendRow')

        if (filterRow.objSelect.length > 0)
          params.FILTER["PROPERTY_973"] = filterRow.objSelect;
        if (filterRow.statObjSelect.length > 0)
          params.FILTER["PROPERTY_581"] = filterRow.statObjSelect;
        //console.log({params})
        const method = "lists.element.get";
        let i = 1;
        let next = 0;
        while (i > 0) {
          params.start = next;
          const reportData = await axios.post(this.url + method, params);
          console.log({ reportData });
          next = reportData.data.next;
          for (const elem of reportData.data.result) {
            if (elem["NAME"] === "Приход денежных средств ДС") {
              const item = {
                obj: "",
                spendCat: "",
                payDate: "",
                spendSum: "",
                payMethod: "",
                stat: "",
              };
              if (elem["PROPERTY_691"])
                item.payDate = Object.values(elem["PROPERTY_691"])[0];
              if (elem["PROPERTY_973"])
                item.obj = Object.values(elem["PROPERTY_973"])[0];
              if (elem["PROPERTY_593"])
                item.spendCat = Object.values(elem["PROPERTY_593"])[0];
              if (elem["PROPERTY_981"])
                item.spendSum = Object.values(elem["PROPERTY_981"])[0];
              if (elem["PROPERTY_573"])
                item.payMethod = Object.values(elem["PROPERTY_573"])[0];
              if (elem["PROPERTY_581"])
                item.stat = Object.values(elem["PROPERTY_581"])[0];
              this.payRow.push(item);
            } else if (elem["NAME"] === "Приход денежных средств Акты") {
              const item = {
                obj: "",
                payDate: "",
                spendCat: "",
                spendSum: "",
                payMethod: "",
                stat: "",
              };
              if (elem["PROPERTY_691"])
                item.payDate = Object.values(elem["PROPERTY_691"])[0];
              if (elem["PROPERTY_973"])
                item.obj = Object.values(elem["PROPERTY_973"])[0];
              if (elem["PROPERTY_593"])
                item.spendCat = Object.values(elem["PROPERTY_593"])[0];
              if (elem["PROPERTY_981"])
                item.spendSum = Object.values(elem["PROPERTY_981"])[0];
              if (elem["PROPERTY_573"])
                item.payMethod = Object.values(elem["PROPERTY_573"])[0];
              if (elem["PROPERTY_581"])
                item.stat = Object.values(elem["PROPERTY_581"])[0];
              this.actRow.push(item);
            } else {
              const item = {
                obj: "",
                spendCat: "",
                spendSum: "",
                payMethod: "",
                stat: "",
              };
              if (elem["PROPERTY_973"])
                item.obj = Object.values(elem["PROPERTY_973"])[0];
              if (elem["PROPERTY_593"])
                item.spendCat = Object.values(elem["PROPERTY_593"])[0];
              if (elem["PROPERTY_591"])
                item.spendSum = Object.values(elem["PROPERTY_591"])[0];
              if (elem["PROPERTY_573"])
                item.payMethod = Object.values(elem["PROPERTY_573"])[0];
              if (elem["PROPERTY_581"])
                item.stat = Object.values(elem["PROPERTY_581"])[0];
              this.spendRow.push(item);
            }
          }
          if (!next) {
            i = 0;
          }
        }
        console.log(this.actRow, "actRow");
        console.log(this.payRow, "payRow");
      } catch (e) {
        console.log(e);
      }
    }, //++
    async getSityStroyRow(filterRow) {
      try {
        await this.normalizeDate(filterRow.datePays);
        const params = {
          IBLOCK_TYPE_ID: "lists",
          IBLOCK_ID: "45",
          FILTER: {
            PROPERTY_973: 60423,
            ">=PROPERTY_691": this.normalDate[0],
            "<=PROPERTY_691": this.normalDate[1],
          },
        };
        console.log("getSityStroyRow");

        const method = "lists.element.get";
        let i = 1;
        let next = 0;
        while (i > 0) {
          params.start = next;
          const reportData = await axios.post(this.url + method, params);
          next = reportData.data.next;
          for (const elem of reportData.data.result) {
            const item = {
              obj: "",
              spendCat: "",
              spendSum: "",
              payMethod: "",
            };
            if (elem["PROPERTY_973"])
              item.obj = Object.values(elem["PROPERTY_973"])[0];
            if (elem["PROPERTY_593"])
              item.spendCat = Object.values(elem["PROPERTY_593"])[0];
            if (elem["PROPERTY_591"])
              item.spendSum = Object.values(elem["PROPERTY_591"])[0];
            if (elem["PROPERTY_581"])
              item.payMethod = Object.values(elem["PROPERTY_581"])[0];
            this.rowCityStroy.push(item);
          }
          if (!next) {
            i = 0;
          }
        }
        console.log(this.rowCityStroy, "sityStroy");
      } catch (e) {
        console.log(e);
      }
    }, //++
    async getReportToFilter() {
      try {
        for (const filterRow of this.filterRows) {
          // console.log({filterRow})
          if (filterRow.datePays.length > 0) {
            this.loading = true;
          } else {
            alert("Вы не выбрали дату! в фильтре #" + filterRow.id);
            this.loading = false;
          }
        }

        if (this.loading) {
          this.spendRow = [];
          this.rowCityStroy = [];
          this.rows = [];
          this.rowData = [[], []];
          this.totalSumToObjs = {
            addTermsCost: 0,
            planSpend: 0,
            planProfit: 0,
            paySum: 0,
            actSum: 0,
            spendSum: 0,
            margin: 0,
            planFactSpendDiff: 0,
            bonus: 0,
            xls: {
              addTermsCost: 0,
              planSpend: 0,
              planProfit: 0,
              paySum: 0,
              actSum: 0,
              spendSum: 0,
              margin: 0,
              planFactSpendDiff: 0,
              bonus: 0,
            },
          };
          this.totalCityStroy = {
            nds: 0,
            it: 0,
            other: 0,
            debt: 0,
            salary: 0,
            km: 0,
            most: 0,
            all: 0,
            profit: 0,
            xls: {
              nds: 0,
              it: 0,
              other: 0,
              debt: 0,
              salary: 0,
              km: 0,
              most: 0,
              all: 0,
              profit: 0,
            },
          };
          console.log(this.filterRows, "filterRows");
          for (const filterRow of this.filterRows) {
            await this.getReport(filterRow);
          }
          //собираем итого
          this.totalSumToObjs.total =
            this.totalSumToObjs.xls.actSum - this.totalSumToObjs.xls.bonus;
          this.totalSumToObjs.xls.total =
            this.totalSumToObjs.xls.actSum - this.totalSumToObjs.xls.bonus;
          this.totalCityStroy.profit =
            this.totalSumToObjs.xls.actSum - this.totalCityStroy.xls.all;
          this.totalCityStroy.xls.profit =
            this.totalSumToObjs.xls.actSum - this.totalCityStroy.xls.all;

          this.totalSumToObjs.bonus = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(Number(this.totalSumToObjs.bonus));
          this.totalCityStroy.other = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.totalCityStroy.other);
          this.totalCityStroy.all = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.totalCityStroy.all);
          this.totalCityStroy.salary = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.totalCityStroy.salary);
          this.totalCityStroy.nds = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.totalCityStroy.nds);
          this.totalCityStroy.it = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.totalCityStroy.it);
          this.totalCityStroy.debt = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.totalCityStroy.debt);
          this.totalCityStroy.km = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.totalCityStroy.km);
          this.totalCityStroy.most = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.totalCityStroy.most);
          this.totalCityStroy.profit = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.totalCityStroy.profit);
          this.totalSumToObjs.total = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.totalSumToObjs.total);
          this.totalSumToObjs.actSum = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.totalSumToObjs.actSum);
          this.totalSumToObjs.profit = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.totalSumToObjs.profit);
          this.totalSumToObjs.paySum = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.totalSumToObjs.paySum);
          this.totalSumToObjs.planSpend = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.totalSumToObjs.planSpend);
          this.totalSumToObjs.spendSum = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.totalSumToObjs.spendSum);
          this.totalSumToObjs.planProfit = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.totalSumToObjs.planProfit);
          this.totalSumToObjs.addTermsCost = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.totalSumToObjs.addTermsCost);
          this.totalSumToObjs.margin = new Intl.NumberFormat("ru-RU", {
            minimumFractionDigits: 2,
          }).format(this.totalSumToObjs.margin);
          this.totalSumToObjs.planFactSpendDiff = new Intl.NumberFormat(
            "ru-RU",
            { minimumFractionDigits: 2 }
          ).format(this.totalSumToObjs.planFactSpendDiff);

          if (this.rows.length > 0) {
            this.rows.sort((a, b) => {
              if (a["contragent"] < b["contragent"]) {
                return -1;
              }
              if (a["contragent"] > b["contragent"]) {
                return 1;
              }
              // a должно быть равным b
              return 0;
            });
          }
          this.loading = false;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getReport(filterRow) {
      try {
        // console.log({filterRow})
        //-------------------------------------------------------------------------
        if (filterRow.objSelect == "60423") {
          if (filterRow.datePays.length > 0)
            await this.getSityStroyRow(filterRow);
        } else {
          if (filterRow.datePays.length > 0) await this.getSpendRow(filterRow);
        }
        console.log("getReport");
        console.log(this.totalCityStroy);
        //-------------------------------------------------------------------------
        //формируем отчет по объекту
        if (filterRow.objSelect == "60423") {
          if (this.rowCityStroy.length > 0) {
            for (const item of this.rowCityStroy) {
              const payMethod = item.payMethod.replace(/[^a-zа-яё0-9\s]/gi, "");
              if (payMethod == "КМ") {
                this.totalCityStroy.km += Number(item.spendSum);
                this.totalCityStroy.xls.km += Number(item.spendSum);
              } else if (payMethod == "Задолженности прошедших периодов") {
                //this.totalCityStroy.xls.all += Number(item.spendSum)
                //this.totalCityStroy.all += Number(item.spendSum)
                this.totalCityStroy.debt += Number(item.spendSum);
                this.totalCityStroy.xls.debt += Number(item.spendSum);
              } else if (payMethod == "Оплата бухгалтерии и айти") {
                this.totalCityStroy.xls.all += Number(item.spendSum);
                this.totalCityStroy.all += Number(item.spendSum);
                this.totalCityStroy.it += Number(item.spendSum);
                this.totalCityStroy.xls.it += Number(item.spendSum);
              } else if (payMethod == "Налоги") {
                this.totalCityStroy.xls.all += Number(item.spendSum);
                this.totalCityStroy.all += Number(item.spendSum);
                this.totalCityStroy.nds += Number(item.spendSum);
                this.totalCityStroy.xls.nds += Number(item.spendSum);
              } else if (payMethod == "Зарплата") {
                this.totalCityStroy.all += Number(item.spendSum);
                this.totalCityStroy.xls.all += Number(item.spendSum);
                this.totalCityStroy.salary += Number(item.spendSum);
                this.totalCityStroy.xls.salary += Number(item.spendSum);
              } else if (payMethod == "Мостовой") {
                this.totalCityStroy.most += Number(item.spendSum);
                this.totalCityStroy.xls.most += Number(item.spendSum);
              } else {
                this.totalCityStroy.other += Number(item.spendSum);
                this.totalCityStroy.xls.all += Number(item.spendSum);
                this.totalCityStroy.all += Number(item.spendSum);
                this.totalCityStroy.xls.other += Number(item.spendSum);
              }
              //this.totalCityStroy.all += Number(item.spendSum)
              //this.totalCityStroy.xls.all += Number(item.spendSum)
            }
          }
        } else {
          for (const obj of this.obj) {
            const row = {
              contragent: "",
              obj: "",
              contract: "",
              addTerms: "",
              addTermsCost: 0,
              planSpend: 0,
              planProfit: 0,
              payDate: [],
              paySum: [],
              actDate: [],
              actSum: [],
              spendCat: [
                "материалы",
                "техника",
                "работа",
                "прочее",
                "наличные",
              ],
              spendSum: [0, 0, 0, 0, 0],
              margin: 0,
              planFactSpendDiff: 0,
              factRevenue: 0,
              factRevenuePercent: 0,
              revenueDiff: 0,
              revenueDiffPercent: 0,
              rowspan: 5,
              summedRow: {
                contragent: "",
                obj: "",
                contract: "",
                addTerms: "Итого: ",
                addTermsCost: 0,
                planSpend: 0,
                planProfit: 0,
                paySum: 0,
                actSum: 0,
                spendCat: "",
                spendSum: 0,
                margin: 0,
                planFactSpendDiff: 0,
                factRevenue: 0,
                factRevenuePercent: 0,
                revenueDiff: 0,
                revenueDiffPercent: 0,
              },
              xls: {
                contragent: "",
                obj: "",
                contract: "",
                addTerms: "",
                addTermsCost: 0,
                planSpend: 0,
                planProfit: 0,
                payDate: [],
                paySum: [],
                actDate: [],
                actSum: [],
                spendCat: [
                  "материалы",
                  "техника",
                  "работа",
                  "прочее",
                  "наличные",
                ],
                spendSum: [0, 0, 0, 0, 0],
                margin: 0,
                planFactSpendDiff: 0,
                factRevenue: 0,
                factRevenuePercent: 0,
                revenueDiff: 0,
                revenueDiffPercent: 0,
                rowspan: 5,
                summedRow: {
                  contragent: "",
                  obj: "",
                  contract: "",
                  addTerms: "Итого: ",
                  addTermsCost: 0,
                  planSpend: 0,
                  planProfit: 0,
                  paySum: 0,
                  actSum: 0,
                  spendCat: "",
                  spendSum: 0,
                  margin: 0,
                  planFactSpendDiff: 0,
                  factRevenue: 0,
                  factRevenuePercent: 0,
                  revenueDiff: 0,
                  revenueDiffPercent: 0,
                },
              },
            };
            const spendData = this.spendRow.filter((e) => {
              return e["obj"] == obj["ID"] && obj["ID"] != "60423";
            });
            let payData = [];
            if (this.payRow.length > 0) {
              payData = this.payRow.filter((e) => {
                return e["obj"] == obj["ID"] && obj["ID"] != "60423";
              });
            }
            let actData = [];
            if (this.actRow.length > 0) {
              actData = this.actRow.filter((e) => {
                return e["obj"] == obj["ID"] && obj["ID"] != "60423";
              });
            }
            //формируем расходы и доходы по объектам
            if (spendData.length > 0) {
              const spentCatID = { 437: 0, 439: 1, 441: 2, 443: 3 };
              //перебираем расходы
              for (const spendItem of spendData) {
                if (spendItem.payMethod == "429") {
                  row.spendSum[4] += Number(spendItem.spendSum);
                  row.xls.spendSum[4] += Number(spendItem.spendSum);
                  row.summedRow.spendSum += Number(spendItem.spendSum);
                  row.xls.summedRow.spendSum += Number(spendItem.spendSum);
                } else {
                  const payMethod = spendItem.stat.replace(
                    /[^a-zа-яё0-9\s]/gi,
                    ""
                  );
                  if (payMethod == "Премия" || payMethod == "Премия\\r\\n") {
                    this.totalSumToObjs.bonus += Number(spendItem.spendSum);
                    this.totalSumToObjs.xls.bonus += Number(spendItem.spendSum);
                  }
                  row.spendSum[spentCatID[spendItem.spendCat]] += Number(
                    spendItem.spendSum
                  );
                  row.xls.spendSum[spentCatID[spendItem.spendCat]] += Number(
                    spendItem.spendSum
                  );
                  row.summedRow.spendSum += Number(spendItem.spendSum);
                  row.xls.summedRow.spendSum += Number(spendItem.spendSum);
                }
              }
              //перебираем дс
              for (const payItem of payData) {
                row.payDate.push(payItem.payDate);
                row.paySum.push(
                  new Intl.NumberFormat("ru-RU", {
                    minimumFractionDigits: 2,
                  }).format(payItem.spendSum)
                );
                row.xls.payDate.push(payItem.payDate);
                row.xls.paySum.push(Number(payItem.spendSum));
                row.summedRow.paySum += Number(payItem.spendSum);
                row.xls.summedRow.paySum += Number(payItem.spendSum);
              }
              //перебираем acts
              for (const actItem of actData) {
                row.actDate.push(actItem.payDate);
                row.actSum.push(
                  new Intl.NumberFormat("ru-RU", {
                    minimumFractionDigits: 2,
                  }).format(actItem.spendSum)
                );
                row.xls.actDate.push(actItem.payDate);
                row.xls.actSum.push(Number(actItem.spendSum));
                row.summedRow.actSum += Number(actItem.spendSum);
                row.xls.summedRow.actSum += Number(actItem.spendSum);
              }

              row.spendSum[0] = new Intl.NumberFormat("ru-RU", {
                minimumFractionDigits: 2,
              }).format(row.spendSum[0]);
              row.spendSum[1] = new Intl.NumberFormat("ru-RU", {
                minimumFractionDigits: 2,
              }).format(row.spendSum[1]);
              row.spendSum[2] = new Intl.NumberFormat("ru-RU", {
                minimumFractionDigits: 2,
              }).format(row.spendSum[2]);
              row.spendSum[3] = new Intl.NumberFormat("ru-RU", {
                minimumFractionDigits: 2,
              }).format(row.spendSum[3]);
              row.spendSum[4] = new Intl.NumberFormat("ru-RU", {
                minimumFractionDigits: 2,
              }).format(row.spendSum[4]);
              row.summedRow.spendSum = new Intl.NumberFormat("ru-RU", {
                minimumFractionDigits: 2,
              }).format(Number(row.summedRow.spendSum));
              row.summedRow.paySum = new Intl.NumberFormat("ru-RU", {
                minimumFractionDigits: 2,
              }).format(Number(row.summedRow.paySum));
              row.summedRow.actSum = new Intl.NumberFormat("ru-RU", {
                minimumFractionDigits: 2,
              }).format(Number(row.summedRow.actSum));

              if (obj["PROPERTY_1005"]) {
                row.contragent = Object.values(obj["PROPERTY_1005"])[0];
                row.xls.contragent = Object.values(obj["PROPERTY_1005"])[0];
              }
              row.obj = obj["NAME"];
              row.xls.obj = obj["NAME"];
              if (obj["PROPERTY_887"]) {
                row.contract = Object.values(obj["PROPERTY_887"])[0];
                row.xls.contract = Object.values(obj["PROPERTY_887"])[0];
              }
              if (obj["PROPERTY_889"]) {
                row.addTerms = Object.values(obj["PROPERTY_889"])[0];
                row.xls.addTerms = Object.values(obj["PROPERTY_889"])[0];
              }
              if (obj["PROPERTY_893"]) {
                row.addTermsCost = new Intl.NumberFormat("ru-RU", {
                  minimumFractionDigits: 2,
                }).format(Number(Object.values(obj["PROPERTY_893"])[0]));
                row.xls.addTermsCost = Number(
                  Object.values(obj["PROPERTY_893"])[0]
                );
                row.summedRow.addTermsCost = new Intl.NumberFormat("ru-RU", {
                  minimumFractionDigits: 2,
                }).format(Number(Object.values(obj["PROPERTY_893"])[0]));
                row.xls.summedRow.addTermsCost = Number(
                  Object.values(obj["PROPERTY_893"])[0]
                );
              }

              if (obj["PROPERTY_881"]) {
                row.planSpend = new Intl.NumberFormat("ru-RU", {
                  minimumFractionDigits: 2,
                }).format(Number(Object.values(obj["PROPERTY_881"])[0]));
                row.xls.planSpend = Number(
                  Object.values(obj["PROPERTY_881"])[0]
                );
                row.summedRow.planSpend = new Intl.NumberFormat("ru-RU", {
                  minimumFractionDigits: 2,
                }).format(Number(Object.values(obj["PROPERTY_881"])[0]));
                row.xls.summedRow.planSpend = Number(
                  Object.values(obj["PROPERTY_881"])[0]
                );
              }
              if (obj["PROPERTY_893"] && obj["PROPERTY_881"]) {
                row.planProfit = new Intl.NumberFormat("ru-RU", {
                  minimumFractionDigits: 2,
                }).format(
                  Number(Object.values(obj["PROPERTY_893"])[0]) -
                    Number(Object.values(obj["PROPERTY_881"])[0])
                );
                row.xls.planProfit =
                  Number(Object.values(obj["PROPERTY_893"])[0]) -
                  Number(Object.values(obj["PROPERTY_881"])[0]);
                row.summedRow.planProfit = new Intl.NumberFormat("ru-RU", {
                  minimumFractionDigits: 2,
                }).format(
                  Number(Object.values(obj["PROPERTY_893"])[0]) -
                    Number(Object.values(obj["PROPERTY_881"])[0])
                );
                row.xls.summedRow.planProfit =
                  Number(Object.values(obj["PROPERTY_893"])[0]) -
                  Number(Object.values(obj["PROPERTY_881"])[0]);
              }
              let i = 0;
              let j = 0;

              this.rowspan = i > j ? i : j;
              if (this.rowspan > row.rowspan) {
                row.rowspan = this.rowspan;
              }

              row.margin = 0; //row.xls.summedRow.paySum - row.xls.summedRow.spendSum
              row.xls.margin = 0; //row.xls.summedRow.paySum - row.xls.summedRow.spendSum
              row.summedRow.margin = 0; //row.xls.summedRow.paySum - row.xls.summedRow.spendSum
              row.xls.summedRow.margin = 0; //row.xls.summedRow.paySum - row.xls.summedRow.spendSum
              row.planFactSpendDiff =
                row.xls.summedRow.planSpend - row.xls.summedRow.spendSum;
              row.xls.planFactSpendDiff =
                row.xls.summedRow.planSpend - row.xls.summedRow.spendSum;
              row.summedRow.planFactSpendDiff =
                row.xls.summedRow.planSpend - row.xls.summedRow.spendSum;
              row.xls.summedRow.planFactSpendDiff =
                row.xls.summedRow.planSpend - row.xls.summedRow.spendSum;
              row.factRevenue =
                row.xls.summedRow.actSum - row.xls.summedRow.spendSum;
              row.xls.factRevenue =
                row.xls.summedRow.actSum - row.xls.summedRow.spendSum;
              row.summedRow.factRevenue =
                row.xls.summedRow.actSum - row.xls.summedRow.spendSum;
              row.xls.summedRow.factRevenue =
                row.xls.summedRow.actSum - row.xls.summedRow.spendSum;
              row.factRevenuePercent =
                row.xls.summedRow.factRevenue / row.xls.summedRow.actSum;
              row.xls.factRevenuePercent =
                row.xls.summedRow.factRevenue / row.xls.summedRow.actSum;
              row.summedRow.factRevenuePercent =
                row.xls.summedRow.factRevenue / row.xls.summedRow.actSum;
              row.xls.summedRow.factRevenuePercent =
                row.xls.summedRow.factRevenue / row.xls.summedRow.actSum;
              row.revenueDiff =
                row.xls.summedRow.planProfit - row.xls.summedRow.factRevenue;
              row.xls.revenueDiff =
                row.xls.summedRow.planProfit - row.xls.summedRow.factRevenue;
              row.summedRow.revenueDiff =
                row.xls.summedRow.planProfit - row.xls.summedRow.factRevenue;
              row.xls.summedRow.revenueDiff =
                row.xls.summedRow.planProfit - row.xls.summedRow.factRevenue;
              row.revenueDiffPercent =
                row.xls.summedRow.revenueDiff / row.xls.planProfit;
              row.xls.revenueDiffPercent =
                row.xls.summedRow.revenueDiff / row.xls.planProfit;
              row.summedRow.revenueDiffPercent =
                row.xls.summedRow.revenueDiff / row.xls.planProfit;
              row.xls.summedRow.revenueDiffPercent =
                row.xls.summedRow.revenueDiff / row.xls.planProfit;

              row.margin = new Intl.NumberFormat("ru-RU", {
                minimumFractionDigits: 2,
              }).format(row.margin);
              row.summedRow.margin = new Intl.NumberFormat("ru-RU", {
                minimumFractionDigits: 2,
              }).format(row.summedRow.margin);
              row.planFactSpendDiff = new Intl.NumberFormat("ru-RU", {
                minimumFractionDigits: 2,
              }).format(row.planFactSpendDiff);
              row.summedRow.planFactSpendDiff = new Intl.NumberFormat("ru-RU", {
                minimumFractionDigits: 2,
              }).format(row.summedRow.planFactSpendDiff);
              row.factRevenue = new Intl.NumberFormat("ru-RU", {
                minimumFractionDigits: 2,
              }).format(row.factRevenue);
              row.summedRow.factRevenue = new Intl.NumberFormat("ru-RU", {
                minimumFractionDigits: 2,
              }).format(row.summedRow.factRevenue);
              row.factRevenuePercent = new Intl.NumberFormat("ru-RU", {
                minimumFractionDigits: 2,
              }).format(row.factRevenuePercent);
              row.summedRow.factRevenuePercent = new Intl.NumberFormat(
                "ru-RU",
                { minimumFractionDigits: 2 }
              ).format(row.summedRow.factRevenuePercent);
              row.revenueDiff = new Intl.NumberFormat("ru-RU", {
                minimumFractionDigits: 2,
              }).format(row.revenueDiff);
              row.summedRow.revenueDiff = new Intl.NumberFormat("ru-RU", {
                minimumFractionDigits: 2,
              }).format(row.summedRow.revenueDiff);
              row.revenueDiffPercent = new Intl.NumberFormat("ru-RU", {
                minimumFractionDigits: 2,
              }).format(row.revenueDiffPercent);
              row.summedRow.revenueDiffPercent = new Intl.NumberFormat(
                "ru-RU",
                { minimumFractionDigits: 2 }
              ).format(row.summedRow.revenueDiffPercent);

              this.rows.push(row);
              this.totalSumToObjs.planSpend += row.xls.summedRow.planSpend;
              this.totalSumToObjs.paySum += row.xls.summedRow.paySum;
              this.totalSumToObjs.actSum += row.xls.summedRow.actSum;
              this.totalSumToObjs.xls.planSpend += row.xls.summedRow.planSpend;
              this.totalSumToObjs.xls.paySum += row.xls.summedRow.paySum;
              this.totalSumToObjs.xls.actSum += row.xls.summedRow.actSum;
              this.totalSumToObjs.spendSum += row.xls.summedRow.spendSum;
              this.totalSumToObjs.xls.spendSum += row.xls.summedRow.spendSum;
              this.totalSumToObjs.planProfit += row.xls.summedRow.planProfit;
              this.totalSumToObjs.xls.planProfit +=
                row.xls.summedRow.planProfit;
              this.totalSumToObjs.addTermsCost +=
                row.xls.summedRow.addTermsCost;
              this.totalSumToObjs.xls.addTermsCost +=
                row.xls.summedRow.addTermsCost;
              this.totalSumToObjs.margin += row.xls.summedRow.margin;
              this.totalSumToObjs.xls.margin += row.xls.summedRow.margin;
              this.totalSumToObjs.planFactSpendDiff +=
                row.xls.summedRow.planFactSpendDiff;
              this.totalSumToObjs.xls.planFactSpendDiff +=
                row.xls.summedRow.planFactSpendDiff;
            }
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async exportXLS() {
      try {
        const outBook = new exeljs.Workbook();
        outBook.views = [
          {
            x: 0,
            y: 500,
            width: 29040,
            height: 15840,
            visibility: "visible",
          },
        ];
        const worksheet = outBook.addWorksheet("Мой отчет");
        worksheet.columns = [
          { header: "Контрагент", key: "contragent", width: 24 },
          { header: "Название объекта", key: "obj", width: 24 },
          { header: "Договор", key: "contract", width: 24 },
          {
            header: "Сумма подписанного ДС с НДС 20%",
            key: "addTermsCost",
            width: 14.65,
            style: { numFmt: "#,0.00" },
          },
          {
            header: "Плановые расходы с НДС 20%",
            key: "planSpend",
            width: 14.65,
            style: { numFmt: "#,0.00" },
          },
          {
            header: "Плановая прибыль с НДС 20%",
            key: "planProfit",
            width: 14.65,
            style: { numFmt: "#,0.00" },
          },
          {
            header: "Дата оплаты",
            key: "payDate",
            width: 14.65,
            style: { numFmt: "#,0.00" },
          },
          {
            header: "Сумма оплаты  с НДС 20%",
            key: "paySum",
            width: 14.65,
            style: { numFmt: "#,0.00" },
          },
          {
            header: "Дата акта выполненых работ",
            key: "actDate",
            width: 14.65,
            style: { numFmt: "#,0.00" },
          },
          {
            header: "Сумма выполненных работ (акт кс-2) с НДС 20%",
            key: "actSum",
            width: 14.65,
            style: { numFmt: "#,0.00" },
          },
          {
            header: "Статья расходов",
            key: "spendCat",
            width: 14.65,
            style: { numFmt: "#,0.00" },
          },
          {
            header: "Сумма с НДС 20%",
            key: "spendSum",
            width: 14.65,
            style: { numFmt: "#,0.00" },
          },
          {
            header: "Доход фактический",
            key: "factRevenue",
            width: 14.65,
            style: { numFmt: "#,0.00" },
          },
          {
            header: "% доходности",
            key: "factRevenuePercent",
            width: 14.65,
            style: { numFmt: "#,0.00" },
          },
          {
            header: "План расход- фактический расход",
            key: "planFactSpendDiff",
            width: 14.65,
            style: { numFmt: "#,0.00" },
          },
          {
            header: "ОТКЛОНЕНИЕ ДОХОДНОСТИ(%)",
            key: "revenueDiff",
            width: 14.65,
            style: { numFmt: "#,0.00" },
          },
        ];
        const myData = this.rows;
        let counterForFormula = [];
        let formulaSumDC = "0";
        let formulaTermsCost = "0";
        let formulaPlanSpend = "0";
        let formulaPaySum = "0";
        let formulaActSum = "0";
        let formulaSpendSum = "0";
        let formulaMargin = "0";
        let formulaPlanFactSpendDiff = "0";
        let counter = 2;
        for (const row of myData) {
          const { rowspan } = row;
          for (let index = 0; index < rowspan; index++) {
            const rowData = {
              ...row.xls,
              payDate: row.xls.payDate[index] || null,
              paySum: row.xls.paySum[index] || null,
              actDate: row.xls.actDate[index] || null,
              actSum: row.xls.actSum[index] || null,
              spendCat: row.xls.spendCat[index] || null,
              spendSum: row.xls.spendSum[index] || null,
            };
            const rowAdd = worksheet.addRow(rowData);
            rowAdd.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
          }
          const rowTotal = {
            ...row.xls.summedRow,
          };
          const rowTotalAdd = worksheet.addRow(rowTotal);
          rowTotalAdd.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "B4F8C8" },
          };
          rowTotalAdd.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };

          worksheet.mergeCells(`A${counter}:A${counter + rowspan - 1}`);
          worksheet.mergeCells(`B${counter}:B${counter + rowspan - 1}`);
          worksheet.mergeCells(`C${counter}:C${counter + rowspan - 1}`);
          worksheet.mergeCells(`D${counter}:D${counter + rowspan - 1}`);
          worksheet.mergeCells(`E${counter}:E${counter + rowspan - 1}`);
          worksheet.mergeCells(`F${counter}:F${counter + rowspan - 1}`);
          worksheet.mergeCells(`M${counter}:M${counter + rowspan - 1}`);
          worksheet.mergeCells(`N${counter}:N${counter + rowspan - 1}`);
          worksheet.mergeCells(`O${counter}:O${counter + rowspan - 1}`);
          worksheet.mergeCells(`P${counter}:P${counter + rowspan - 1}`);
          worksheet.mergeCells(`Q${counter}:Q${counter + rowspan - 1}`);
          worksheet.mergeCells(`R${counter}:R${counter + rowspan - 1}`);
          worksheet.mergeCells(`S${counter}:S${counter + rowspan - 1}`);

          //формируем массив номеров итоговых строк
          counterForFormula.push(counter + rowspan);
          //Плановая прибыль с НДС 20%
          worksheet.getCell(`F${counter + rowspan - 1}`).value = {
            formula: `D${counter + rowspan}-E${counter + rowspan}`,
            result: 7,
          };
          //Плановая прибыль с НДС 20%
          worksheet.getCell(`F${counter + rowspan}`).value = {
            formula: `F${counter + rowspan - 5}`,
            result: 7,
          };
          //Плановые расходы с НДС 20%
          worksheet.getCell(`E${counter + rowspan}`).value = {
            formula: `E${counter + rowspan - 5}`,
            result: 7,
          };
          //Сумма подписанного ДС с НДС 20%
          worksheet.getCell(`D${counter + rowspan}`).value = {
            formula: `D${counter + rowspan - 5}`,
            result: 7,
          };
          //сумма всех полей актов
          worksheet.getCell(`H${counter + rowspan}`).value = {
            formula: `SUM(H${counter}:H${counter + rowspan - 1})`,
            result: 7,
          };
          //сумма всех полей КС
          worksheet.getCell(`J${counter + rowspan}`).value = {
            formula: `SUM(J${counter}:J${counter + rowspan - 1})`,
            result: 7,
          };
          //сумма всех расходов
          worksheet.getCell(`L${counter + rowspan}`).value = {
            formula: `SUM(L${counter}:L${counter + rowspan - 1})`,
            result: 7,
          };
          //Доход фактический
          worksheet.getCell(`M${counter + rowspan - 1}`).value = {
            formula: `J${counter + rowspan}-L${counter + rowspan}`,
            result: 7,
          };
          worksheet.getCell(`M${counter + rowspan}`).value = {
            formula: `J${counter + rowspan}-L${counter + rowspan}`,
            result: 7,
          };
          //% дохода
          worksheet.getCell(`N${counter + rowspan - 1}`).value = {
            formula: `M${counter + rowspan}/J${counter + rowspan}`,
            result: 7,
          };
          worksheet.getCell(`N${counter + rowspan}`).value = {
            formula: `M${counter + rowspan}/J${counter + rowspan}`,
            result: 7,
          };
          //План расход- фактический расход
          worksheet.getCell(`O${counter + rowspan - 1}`).value = {
            formula: `E${counter + rowspan}-L${counter + rowspan}`,
            result: 7,
          };
          worksheet.getCell(`O${counter + rowspan}`).value = {
            formula: `E${counter + rowspan}-L${counter + rowspan}`,
            result: 7,
          };
          //ОТКЛОНЕНИЕ ДОХОДНОСТИ
          worksheet.getCell(`P${counter + rowspan - 1}`).value = {
            formula: `O${counter + rowspan}/J${counter + rowspan}`,
            result: 7,
          };
          worksheet.getCell(`P${counter + rowspan}`).value = {
            formula: `O${counter + rowspan}/J${counter + rowspan}`,
            result: 7,
          };

          counter += rowspan + 1;
        }

        const rowTotalObj = {
          obj: "ИТОГИ ПО ВСЕМ ОБЪЕКТАМ",
          addTermsCost: this.totalSumToObjs.xls.addTermsCost,
          planSpend: this.totalSumToObjs.xls.planSpend,
          planProfit: this.totalSumToObjs.xls.planProfit,
          payDate: null,
          paySum: this.totalSumToObjs.xls.paySum,
          actDate: null,
          actSum: this.totalSumToObjs.xls.actSum,
          spendCat: null,
          spendSum: this.totalSumToObjs.xls.spendSum,
          margin: this.totalSumToObjs.xls.margin,
          planFactSpendDiff: this.totalSumToObjs.xls.planFactSpendDiff,
        };
        const rowTotalObjAdd = worksheet.addRow(rowTotalObj);
        rowTotalObjAdd.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "868B8E" },
        };
        rowTotalObjAdd.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        //строка "итого"
        //сумма всех полей итого по объекту
        for (const rowNumberTotal of counterForFormula) {
          formulaSumDC += `+D${rowNumberTotal}`;
          formulaTermsCost += `+E${rowNumberTotal}`;
          formulaPlanSpend += `+F${rowNumberTotal}`;
          formulaPaySum += `+H${rowNumberTotal}`;
          formulaActSum += `+J${rowNumberTotal}`;
          formulaSpendSum += `+L${rowNumberTotal}`;
          formulaMargin += `+M${rowNumberTotal}`;
          formulaPlanFactSpendDiff += `+O${rowNumberTotal}`;
        }
        worksheet.getCell(`D${counter}`).value = {
          formula: `${formulaSumDC}`,
          result: 7,
        };
        worksheet.getCell(`E${counter}`).value = {
          formula: `${formulaTermsCost}`,
          result: 7,
        };
        worksheet.getCell(`F${counter}`).value = {
          formula: `${formulaPlanSpend}`,
          result: 7,
        };
        worksheet.getCell(`H${counter}`).value = {
          formula: `${formulaPaySum}`,
          result: 7,
        };
        worksheet.getCell(`J${counter}`).value = {
          formula: `${formulaActSum}`,
          result: 7,
        };
        worksheet.getCell(`L${counter}`).value = {
          formula: `${formulaSpendSum}`,
          result: 7,
        };
        worksheet.getCell(`M${counter}`).value = {
          formula: `${formulaMargin}`,
          result: 7,
        };
        worksheet.getCell(`O${counter}`).value = {
          formula: `${formulaPlanFactSpendDiff}`,
          result: 7,
        };
        //TODO тут добавляем формулу для итого по объектам

        const rowBonusObj = {
          obj: "ВСЕ ВЫДАННЫЕ ПРЕМИИ с объеков :",
          spendSum: this.totalSumToObjs.xls.bonus,
        };
        const rowBonusObjAdd = worksheet.addRow(rowBonusObj);
        rowBonusObjAdd.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "868B8E" },
        };
        rowBonusObjAdd.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        //
        const rowTotalProfit = {
          obj: "Итого Доход :",
          spendSum: this.totalSumToObjs.xls.total,
        };
        const rowTotalProfitAdd = worksheet.addRow(rowTotalProfit);
        rowTotalProfitAdd.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "868B8E" },
        };
        rowTotalProfitAdd.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        worksheet.getCell(`L${counter + 2}`).value = {
          formula: `L${counter}-L${counter + 1}`,
          result: 7,
        };
        counter += 3;

        const rowSityStroy = {
          obj: "Расходы Сити-Строй :",
          spendSum: this.totalCityStroy.xls.all,
        };
        const rowSityStroyAdd = worksheet.addRow(rowSityStroy);
        rowSityStroyAdd.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "868B8E" },
        };
        rowSityStroyAdd.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        worksheet.getCell(`L${counter}`).value = {
          formula: `SUM(L${counter + 1}:L${counter + 6})`,
          result: 7,
        };

        const rowSityStroyNds = {
          obj: "Налоги (предыдущий квартал) :",
          spendSum: this.totalCityStroy.xls.nds,
        };
        const rowSityStroyNdsAdd = worksheet.addRow(rowSityStroyNds);
        rowSityStroyNdsAdd.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "868B8E" },
        };
        rowSityStroyNdsAdd.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        const rowSityStroyOther = {
          obj: "Прочее :",
          spendSum: this.totalCityStroy.xls.other,
        };
        const rowSityStroyOtherAdd = worksheet.addRow(rowSityStroyOther);
        rowSityStroyOtherAdd.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "868B8E" },
        };
        rowSityStroyOtherAdd.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        const rowSityStroyIT = {
          obj: "Айти+Бухгалтер :",
          spendSum: this.totalCityStroy.xls.it,
        };
        const rowSityStroyITAdd = worksheet.addRow(rowSityStroyIT);
        rowSityStroyITAdd.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "868B8E" },
        };
        rowSityStroyITAdd.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        const rowSityStroySalary = {
          obj: "ЗП :",
          spendSum: this.totalCityStroy.xls.salary,
        };
        const rowSityStroySalaryAdd = worksheet.addRow(rowSityStroySalary);
        rowSityStroySalaryAdd.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "868B8E" },
        };
        rowSityStroySalaryAdd.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        const rowSityStroyDebt = {
          obj: "Задолженности прошедших периодов :",
          spendSum: this.totalCityStroy.xls.debt,
        };
        const rowSityStroyDebtAdd = worksheet.addRow(rowSityStroyDebt);
        rowSityStroyDebtAdd.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "868B8E" },
        };
        rowSityStroyDebtAdd.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        const rowSityStroyTotalProfit = {
          obj: "Итоговый доход Сити-Строя :",
          spendSum: 0,
        };
        const rowSityStroyTotalProfitAdd = worksheet.addRow(
          rowSityStroyTotalProfit
        );
        rowSityStroyTotalProfitAdd.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "868B8E" },
        };
        rowSityStroyTotalProfitAdd.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        const rowSityStroyLaterProfit = {
          obj: "Доход предыдущего квартала :",
          spendSum: 0,
        };
        const rowSityStroyLaterProfitAdd = worksheet.addRow(
          rowSityStroyLaterProfit
        );
        rowSityStroyLaterProfitAdd.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "868B8E" },
        };
        rowSityStroyLaterProfitAdd.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        const rowSityStroyProfit = {
          obj: "Доход Сити-Строя :",
          spendSum: this.totalCityStroy.xls.profit,
        };
        const rowSityStroyProfitAdd = worksheet.addRow(rowSityStroyProfit);
        rowSityStroyProfitAdd.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "868B8E" },
        };
        rowSityStroyProfitAdd.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        const rowZorin = {
          obj: "Премия Зорин :",
          spendSum: 0,
        };
        const rowZorinAdd = worksheet.addRow(rowZorin);
        rowZorinAdd.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "868B8E" },
        };
        rowZorinAdd.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        const rowHamzina = {
          obj: "Премия Хамзина :",
          spendSum: 0,
        };
        const rowHamzinaAdd = worksheet.addRow(rowHamzina);
        rowHamzinaAdd.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "868B8E" },
        };
        rowHamzinaAdd.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        const rowSityStroyClearProfit = {
          obj: "Чистый доход Сити-Строя :",
          spendSum: 0,
        };
        const rowSityStroyClearProfitAdd = worksheet.addRow(
          rowSityStroyClearProfit
        );
        rowSityStroyClearProfitAdd.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "868B8E" },
        };
        rowSityStroyClearProfitAdd.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        const rowSityStroyKM = {
          obj: "КМ :",
          spendSum: this.totalCityStroy.xls.km,
        };
        const rowSityStroyKMAdd = worksheet.addRow(rowSityStroyKM);
        rowSityStroyKMAdd.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "868B8E" },
        };
        rowSityStroyKMAdd.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        const rowSityStroyMost = {
          obj: "Мостовой :",
          spendSum: this.totalCityStroy.xls.most,
        };
        const rowSityStroyMostAdd = worksheet.addRow(rowSityStroyMost);
        rowSityStroyMostAdd.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "868B8E" },
        };
        rowSityStroyMostAdd.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        const buffer = await outBook.xlsx.writeBuffer();
        const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const blob = new Blob([buffer], { type: fileType });
        fileWrite(blob, "Quarter_report.xlsx");
      } catch (e) {
        console.log(e);
      }
    },
  },
  mounted() {
    this.getObj();
  },
};
</script>

<style scoped></style>
